import {
  CommandButton,
  IContextualMenuProps,
  IconButton,
  Label,
  TooltipHost,
} from "@fluentui/react";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { useEffect, useState } from "react";
import themeBase from "../../utils/theme/themeBase";
import COLORES from "../../utils/theme/colores";

interface IPaginationV8 {
  onChangeTake?: (take: number) => void;
  onChangeSkip?: (skip: number) => void;
  totalPagesPagination?: number;
  takePagination?: number;
  skipPagination?: number;
  isLoading?: boolean;
  total?: number;
  cantidad?: number;
}

export const PaginationV8 = (props: IPaginationV8) => {
  const defaultItemsCount = props.takePagination + ""; // Definir la variable
  const initialState = {}; // Estado inicial vacío
  initialState[`${defaultItemsCount} Items`] = [defaultItemsCount];

  const [checkedValues, setCheckedValues] =
    useState<Record<string, string[]>>(initialState);
  const [skipPagination, setSkipPagination] = useState<number>(0);
  const [actualPage, setActualPage] = useState<number>(1);

  const onCheckedValueChange = (key: string, text: string) => {
    setCheckedValues((checkedValues) => ({ [text]: [key] }));
    if (props.onChangeTake) props.onChangeTake(Number.parseInt(key));
  };
  const getCurrentTakeValue = () => {
    const takeKey = Object.keys(checkedValues)[0];

    return Number(checkedValues[takeKey][0]);
  };

  useEffect(() => {
    setSkipPagination(props.skipPagination!);
    const take = getCurrentTakeValue();
    const newActualPage = Math.floor(skipPagination / take) + 1;
    setActualPage(newActualPage);
  }, [skipPagination, props.skipPagination]);

  const handleClick = (text: string) => {
    let newSkip;
    const takeValue = getCurrentTakeValue();

    switch (text) {
      case "Inicio":
        newSkip = 0;
        break;
      case "Anterior":
        newSkip = Math.max(0, skipPagination - takeValue);
        break;
      case "Siguiente":
        newSkip = skipPagination + takeValue;
        break;
      case "Último":
        newSkip = (props.totalPagesPagination! - 1) * takeValue;
        break;
      default:
        break;
    }
    setSkipPagination(newSkip);
    if (props.onChangeSkip) props.onChangeSkip(newSkip);
  };

  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: "10",
        text: "10 Items",
        // iconProps: { iconName: "Mail" },
        onClick: () => {
          onCheckedValueChange("10", "10 Items");
        },
      },
      {
        key: "50",
        text: "50 Items",
        onClick: () => {
          onCheckedValueChange("50", "50 Items");
        },
      },
      {
        key: "100",
        text: "100 Items",
        onClick: () => {
          onCheckedValueChange("100", "100 Items");
        },
      },
    ],
  };

  return (
    <div
      key="superpagTa"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div
        style={{ display: "flex", fontSize: "25px" }}
        key={"superLeftPagination"}
      >
        {/* <Label
          style={{
            padding: "0px 5px",
          }}
        >
          {"Mostrando "}
        </Label> */}
        {props.isLoading ? (
          <Spinner key="spnnCantPag" size={SpinnerSize.xSmall} />
        ) : (
          <Label
            key={"cantpag"}
            style={{
              padding: "0px 5px",
            }}
          >
            {props?.cantidad}
          </Label>
        )}
        <Label
          key={"cantitems"}
          style={{
            padding: "0px 5px",
          }}
        >
          {" items de "}
        </Label>
        {props.isLoading ? (
          <Spinner key="spnnload" size={SpinnerSize.xSmall} />
        ) : (
          <Label
            key={"cantTotal"}
            style={{
              padding: "0px 5px",
            }}
          >
            {props?.total}
          </Label>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center" }} key={"SuperMenu"}>
        <div key={"menu"}>
          <CommandButton
            key={"CmdButon"}
            text={checkedValues && Object.keys(checkedValues)[0]}
            menuProps={menuProps}
          />
        </div>

        <div key={"descripcion"} style={{ display: "flex" }}>
          <Label
            key={"labeldes"}
            style={{
              padding: "0px 5px",
            }}
          >
            {"Página "}
          </Label>
          <Label
            key={"actPage"}
            style={{
              padding: "0px 5px",
            }}
          >
            {`${actualPage} `}
          </Label>

          <Label
            key={"de"}
            style={{
              padding: "0px 5px",
            }}
          >
            {" de "}
          </Label>
          {props.isLoading ? (
            <Spinner size={SpinnerSize.xSmall} />
          ) : (
            <Label
              key={"tpag"}
              style={{
                padding: "0px 5px",
              }}
            >
              {props.totalPagesPagination}
            </Label>
          )}
        </div>
        <div key={"opciones"}>
          <>
            <TooltipHost key="TintPAg" content="Inicio">
              <IconButton
                key="iniPAg"
                iconProps={{ iconName: "ChevronLeftEnd6" }}
                aria-label="Emoji"
                style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                className={themeBase.classNamesIcon.iconFont}
                disabled={actualPage == 1}
                // checked={checked}
                onClick={() => handleClick("Inicio")}
              />
            </TooltipHost>
            <TooltipHost key="TantPAg" content="Anterior">
              <IconButton
                key="antPAg"
                iconProps={{ iconName: "ChevronLeftSmall" }}
                aria-label="Emoji"
                style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                className={themeBase.classNamesIcon.iconFont}
                onClick={() => handleClick("Anterior")} // checked={checked}
              />
            </TooltipHost>

            <TooltipHost key="TsigPAg" content="Siguiente">
              <IconButton
                key="sigPAg"
                iconProps={{ iconName: "ChevronRightSmall" }}
                aria-label="Emoji"
                style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                className={themeBase.classNamesIcon.iconFont}
                onClick={() => handleClick("Siguiente")}
              />
            </TooltipHost>

            <TooltipHost key="TultPAg" content="Ultimo">
              <IconButton
                key="ultPAg"
                iconProps={{ iconName: "ChevronRightEnd6" }}
                aria-label="Emoji"
                style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                className={themeBase.classNamesIcon.iconFont}
                onClick={() => handleClick("Último")}
              />
            </TooltipHost>
          </>
        </div>
      </div>
    </div>
  );
};
